<template>
  <div>
    <div class="breadcrumb">
      <h1 style="color: #AC8400;">Report</h1>
    </div>

    <!-- Breadcrumbs -->
    <div style="padding: 10px; background-color: #F2F2F2">
      <router-link to="/dashboard">Dashboard</router-link> /
      <b>Loyalty Point System</b> /
      <b>Report</b>
    </div>
    <!-- End of breadcrumbs -->

    <div class="separator-breadcrumb border-top"></div>

    <div class="row mb-3">
      <div class="col-12 col-lg-6 col-sm-12"></div>

      <div
        class="col-12 col-lg-6 col-sm-12 d-flex flex-column flex-sm-row align-items-center"
      >
        <span class="m-auto"></span>
        <div class="btn-group" role="group">
          <button
            class="btn btn-secondary"
            id="btn-active"
            :class="{ 'change-background': activeClick }"
            @click="insertVendortoTable()"
            type="button"
          >
            Vendor
          </button>
          <button
            class="btn btn-secondary"
            id="btn-inactive"
            :class="{ 'change-background': inactiveClick }"
            @click="insertCharitytoTable()"
            type="button"
          >
            Charity
          </button>
          <button
            class="btn btn-secondary"
            id="btn-inactive"
            :class="{ 'change-background': affiliateClick }"
            @click="insertAffiliatetoTable()"
            type="button"
          >
            Affiliate
          </button>
        </div>
      </div>
    </div>

    <div class="row mb-4">
      <div class="col-md-12 mb-4">
        <!-- Card -->
        <div class="card text-left">
          <div class="card-body">
            <div v-show="activeClick" id="active" class="">
              <h4 class="card-title mb-3">
                <b>Vendor Report</b>
              </h4>

              <div class="d-flex flex-row flex-wrap mb-5 _filterClass">
                <div class="flex-grow-1 d-flex flex-column mr-2">
                  <label><b>Period From</b></label>
                  <div class="d-flex flex-row">
                    <select class="form-control" v-model="filterData.month_from" required>
                      <option value="">Select Month</option>
                      <option v-for="month in months" :key="month.value" :value="month.value">{{ month.name }}</option>
                    </select>

                    <input type="number" class="form-control" v-model="filterData.year_from" required />
                  </div>
                </div>

                <div class="flex-grow-1 d-flex flex-column mr-2">
                  <label><b>Period To</b></label>
                  <div class="d-flex flex-row">
                    <select class="form-control" v-model="filterData.month_to" required>
                      <option value="">Select Month</option>
                      <option v-for="month in months" :key="month.value" :value="month.value">{{ month.name }}</option>
                    </select>

                    <input type="number" class="form-control" v-model="filterData.year_to" required />
                  </div>
                </div>

                <div class="flex-shrink-1 filter-buttons mr-2">
                  <div class="d-flex flex-row">
                    <button class="btn btn-rounded btn-primary mr-2" style="width: 150px;" @click="filterPeriod">
                      Filter
                    </button>
                    <button class="btn btn-rounded btn-primary" style="width: 150px;" @click="resetFilter">
                      Reset
                    </button>
                  </div>
                </div>

                <div class="d-flex flex-column mt-2">
                  <label><b>Total Outstanding Liability</b></label>
                  <label>{{`$ ${outstanding}`}}</label>
                </div>
              </div>

              
              <!-- Active -->
              <div class="table-responsive">
                <table
                  id="payout_tbl"
                  class="display table table-striped table-bordered"
                  style="width:100%; text-align: center;"
                >
                  <thead>
                    <tr>
                      <th>No.</th>
                      <th>Company Name</th>
                      <th>Total Items Redeemed</th>
                      <th>Paid</th>
                      <th>Unpaid</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(vendor, index) in vendors" :key="index">
                      <td width="10%">{{ index + 1 }}</td>
                      <td>{{ vendor.name }}</td>
                      <td>{{ vendor.redeemed }}</td>
                      <td>${{ vendor.paid }}</td>
                      <td>${{ vendor.unpaid }}</td>
                      <td width="20%">
                        <router-link
                          :to="{
                            name: 'report-update',
                            params: { id: vendor.id, type: 'vendor' }
                          }"
                          class="btn btn-primary btn-rounded btn-block"
                        >
                          View Payouts
                        </router-link>
                      </td>
                    </tr>
                  </tbody>
                  <tfoot style="font-weight: bold;">
                    <tr>
                      <td></td>
                      <td>Sub Total</td>
                      <td>{{ sub_total.total_redeemed }}</td>
                      <td>{{ sub_total.total_paid }}</td>
                      <td>{{ sub_total.total_unpaid }}</td>
                      <td></td>
                    </tr>
                  </tfoot>
                </table>
              </div>
            </div>

            <div v-show="inactiveClick" id="active" class="">
              <h4 class="card-title mb-3">
                <b>Charity Report</b>
              </h4>
              <!-- Active -->
              <div class="table-responsive">
                <table
                  id="charity_tbl"
                  class="display table table-striped table-bordered"
                  style="width:100%; text-align: center;"
                >
                  <thead>
                    <tr>
                      <th>No.</th>
                      <th>Charity Name</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(charity, index) in charities" :key="index">
                      <td width="10%">{{ index + 1 }}</td>
                      <td>{{ charity.name }}</td>
                      <td width="20%">
                        <router-link
                          :to="{
                            name: 'charity-donations',
                            params: { id: charity.id }
                          }"
                          class="btn btn-primary btn-rounded btn-block"
                        >
                          View Donations
                        </router-link>
                        <!-- <router-link
                          :to="{
                            name: 'charity-report-details',
                            params: { id: charity.id, type: 'charity' }
                          }"
                          class="btn btn-primary btn-rounded btn-block"
                        >
                          View Detail
                        </router-link> -->
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>

            <div v-show="affiliateClick" id="active" class="">
              <h4 class="card-title mb-3">
                <b>Affiliate Report</b>
              </h4>

              <div class="table-responsive">
                <table
                  id="affiliate_tbl"
                  class="display table table-striped table-bordered"
                  style="width:100%; text-align: center;"
                >
                  <thead>
                    <tr>
                      <th>No.</th>
                      <th>Affiliator</th>
                      <th>Referral Code</th>
                      <th>Type</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(affiliate, index) in affiliates" :key="index">
                      <td width="10%">{{ index + 1 }}</td>
                      <td>{{ affiliate.name }}</td>
                      <td>{{ affiliate.referral_code }}</td>
                      <td>{{ affiliate.type == 1 ? "Media" : "Promoter" }}</td>
                      <td width="20%">
                        <router-link
                          :to="{
                            name: 'affiliate-refferal-used',
                            params: { id: affiliate.balance_id }
                          }"
                          class="btn btn-primary btn-rounded btn-block"
                        >
                          View Used
                        </router-link>
                        <router-link
                          v-show="affiliate.type == 2"
                          :to="{
                            name: 'affiliate-report',
                            params: { id: affiliate.balance_id }
                          }"
                          class="btn btn-primary btn-rounded btn-block"
                        >
                          View Payouts
                        </router-link>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>

            <loading
              :active.sync="isLoading"
              :can-cancel="false"
              :is-full-page="fullPage"
            ></loading>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import axios from "axios";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";

export default {
  name: "report-view",
  components: {
    Loading
  },
  props: ["type"],


  data() {
    return {
      vendors: [],
      charities: [],
      affiliates: [],
      total_redeems: [],
      activeClick: true,
      inactiveClick: false,
      affiliateClick: false,
      isLoading: false,
      fullPage: true,

      filterData: {
        month_from: '',
        month_to: '',
        year_from: '',
        year_to: '',
      },

      months: [
        {value: 1, name: 'January'},
        {value: 2, name: 'February'},
        {value: 3, name: 'March'},
        {value: 4, name: 'April'},
        {value: 5, name: 'May'},
        {value: 6, name: 'June'},
        {value: 7, name: 'July'},
        {value: 8, name: 'August'},
        {value: 9, name: 'September'},
        {value: 10, name: 'October'},
        {value: 11, name: 'November'},
        {value: 12, name: 'December'},
      ],

      outstanding: '',
      sub_total: null,
    };
  },

  methods: {
    async loadDetails(extraRequest = false) {
      this.isLoading = true;
      if (!this.checkToken()) {
        swal({
          icon: "error",
          text: "You are not authorised"
        });
        this.isLoading = false;
        return;
      }

      const urlRequest = extraRequest ? `/vendor?month_from=${this.filterData.month_from}&month_to=${this.filterData.month_to}&year_from=${this.filterData.year_from}&year_to=${this.filterData.year_to}` : `/vendor`

      try {
        let result = await axios.get(axios.lpsURL +urlRequest, {
          headers: {
            Authorization: "Bearer " + this.checkToken()
          }
        });

        this.vendors = result.data.vendor;
        this.total_redeems = result.data.total_redeems;
        this.outstanding = result.data.outstanding;
        this.sub_total = result.data.sub_total;

        this.vendors.forEach(vendor => {
          this.total_redeems.forEach(redeem => {
            if (redeem.vendor_id == vendor.id) {
              vendor.redeemed = redeem.redeemed;
            }
          });
        });
        this.isLoading = false;
      } catch (error) {
        console.log(error);
        this.isLoading = false;
        return;
      }
    },

    async loadCharities() {
      this.isLoading = true;
      if (!this.checkToken()) {
        swal({
          icon: "error",
          text: "You are not authorised"
        });
        this.isLoading = false;
        return;
      }
      try {
        let result = await axios.get(axios.lpsURL + "/charity/get?active=1", {
          headers: {
            Authorization: "Bearer " + this.checkToken()
          }
        });
        this.charities = result.data.charities;
        this.isLoading = false;
      } catch (error) {
        console.log(error);
        this.isLoading = false;
      }
    },

    async loadAffiliates() {
      this.isLoading = true;
      if (!this.checkToken()) {
        swal({
          icon: "error",
          text: "You are not authorised"
        });
        this.isLoading = false;
        return;
      }
      try {
        let result = await axios.get(axios.lpsURL + "/affiliate", {
          headers: {
            Authorization: "Bearer " + this.checkToken()
          }
        });

        result.data.forEach(item => {
          item.balance.forEach(balance => {
            this.affiliates.push({
              affiliate_id: item.id,
              balance_id: balance.id,
              name: item.name,
              referral_code: balance.account_number,
              type: balance.referral_detail.type
            });
          });
        });
        this.isLoading = false;
      } catch (error) {
        console.log(error);
        return;
        this.isLoading = false;
      }
    },

    insertVendortoTable() {
      this.activeClick = true;
      this.inactiveClick = false;
      this.affiliateClick = false;
    },

    insertCharitytoTable() {
      this.activeClick = false;
      this.inactiveClick = true;
      this.affiliateClick = false;
    },

    insertAffiliatetoTable() {
      this.affiliateClick = true;
      this.activeClick = false;
      this.inactiveClick = false;
    },

    async resetFilter() {
      this.destroyDatatable();
      await this.loadDetails();
      this.createDatatable();
    },

    checkToken() {
      let token = localStorage.getItem("token");

      // check if has token
      if (token == null || token == "") {
        return false;
      }
      token = JSON.parse(token);
      token = token.access_token;

      return token;
    },

    getRandomInt(min, max) {
      return Math.floor(Math.random() * (max - min + 1)) + min;
    },

    createDatatable() {
      $("#payout_tbl").DataTable({
        pageLength: 5,
        dom: "Bfrtip",
        buttons: [
          {
            extend: "excelHtml5",
            exportOptions: {
              columns: [0, 1, 2, 3]
            },
            filename: 'Vendor Reports',
            title: 'Vendor Reports',

          },
          {
            extend: "pdfHtml5",
            exportOptions: {
              columns: [0, 1, 2, 3]
            },
            filename: 'Vendor Reports',
            title: 'Vendor Reports',

          }
        ]
      });
      $("#charity_tbl").DataTable({
        pageLength: 5,
        dom: "Bfrtip",
        buttons: [
          {
            extend: "excelHtml5",
            exportOptions: {
              columns: [0, 1]
            },
            filename: 'Charity Reports',
            title: 'Charity Reports',
          },
          {
            extend: "pdfHtml5",
            exportOptions: {
              columns: [0, 1]
            },
            filename: 'Charity Reports',
            title: 'Charity Reports',

          }
        ]
      });
      $("#affiliate_tbl").DataTable({
        pageLength: 5,
        dom: "Bfrtip",
        buttons: [
          {
            extend: "excelHtml5",
            exportOptions: {
              columns: [0, 1, 2, 3]
            },
            filename: 'Affiliate Report',
            title: 'Affiliate Report',

          },
          {
            extend: "pdfHtml5",
            exportOptions: {
              columns: [0, 1,2 ,3]
            },
            filename: 'Affiliate Report',
            title: 'Affiliate Report',

          }
        ]
      });
    },

    destroyDatatable() {
      $("#payout_tbl")
        .DataTable()
        .destroy();

      $("#charity_tbl")
        .DataTable()
        .destroy();

      $("#affiliate_tbl")
        .DataTable()
        .destroy();
    },

    checkTypeDetails()
    {
      let type = this.$route.params.type;
      if(type == 'vendor') return this.insertVendortoTable();
      if(type == 'charity') return this.insertCharitytoTable();
      if(type == 'affiliate') return this.insertAffiliatetoTable();
    },

    areAllFiltersFilled() {
      return Object.values(this.filterData).every(value => value !== '' && value !== null);
    },

    async filterPeriod() {
      if (!this.areAllFiltersFilled()) {
        swal({
          icon: 'error',
          text: 'Please enter all fields'
        });
        return; 
      }

      this.destroyDatatable();
      await this.loadDetails(true);
      this.createDatatable();
    },

    async resetFilter() {
      this.destroyDatatable();
      await this.loadDetails();
      this.createDatatable();
      this.resetFilteredData();
    },

    async resetFilteredData() {
      this.filterData = {
        month_from: '',
        month_to: '',
        year_from: '',
        year_to: ''
      };
    },
  },

  async created() {
    await this.loadDetails();
    await this.loadCharities();
    await this.loadAffiliates();
    this.checkTypeDetails();
    this.createDatatable();

    this.$watch(
      () => this.$route.params.type, (params) => {
          this.checkTypeDetails();
      }
    )
  }
};
</script>

<style>
.change-background {
  background-color: #5f5f5f;
  color: white;
}

.filter-buttons {
  align-self: end;
  justify-content: flex-end;
}

._filterClass{
  justify-content: space-between !important;
}
</style>
